import React from 'react'

const PickContextMenuArrow = () => (
  <svg width="11px" height="19px" viewBox="0 0 11 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="arrow"
        transform="translate(1.192388, 9.192388) rotate(45.000000) translate(-1.192388, -9.192388) translate(-5.307612, 2.692388)"
        fill="#121212"
      >
        <rect id="line" x="12" y="2.82201654e-07" width="1" height="13" />
        <rect id="line" x="0" y="0" width="13" height="1" />
      </g>
    </g>
  </svg>
)

export default PickContextMenuArrow
